import { ProductSurfaceDefinition } from '@/types/surfaces';
import { BoxModelStyle } from '@/three/types';

export const PRODUCT_SURFACES: Record<string, ProductSurfaceDefinition[]> = {
	'box-flap': [
		{
			id: 'external-front',
			label: 'Front (zewnętrzny)',
			group: 'external',
			description: 'Główna ściana frontowa widoczna przy otwieraniu pudełka.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-back',
			label: 'Tył (zewnętrzny)',
			group: 'external',
			description: 'Tylna ściana pudełka – często wykorzystywana na informacje adresowe.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-left',
			label: 'Bok lewy (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'external-right',
			label: 'Bok prawy (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'external-top-front-flap',
			label: 'Klapa górna przednia (zewnętrzna)',
			group: 'external',
			description: 'Przednia klapa zamykająca – widoczna z góry po złożeniu pudełka.',
			axes: { horizontal: 'longFlapWidth', vertical: 'longFlapDepth' },
		},
		{
			id: 'external-top-back-flap',
			label: 'Klapa górna tylna (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'longFlapWidth', vertical: 'longFlapDepth' },
		},
		{
			id: 'external-top-left-flap',
			label: 'Klapa górna lewa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'sideFlapWidth', vertical: 'shortFlapDepth' },
		},
		{
			id: 'external-top-right-flap',
			label: 'Klapa górna prawa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'sideFlapWidth', vertical: 'shortFlapDepth' },
		},
		{
			id: 'external-bottom',
			label: 'Dół (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
		{
			id: 'internal-front',
			label: 'Front (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'internal-back',
			label: 'Tył (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'internal-left',
			label: 'Bok lewy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'internal-right',
			label: 'Bok prawy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'internal-top-front-flap',
			label: 'Klapa górna przednia (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'longFlapWidth', vertical: 'longFlapDepth' },
		},
		{
			id: 'internal-top-back-flap',
			label: 'Klapa górna tylna (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'longFlapWidth', vertical: 'longFlapDepth' },
		},
		{
			id: 'internal-top-left-flap',
			label: 'Klapa górna lewa (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'sideFlapWidth', vertical: 'shortFlapDepth' },
		},
		{
			id: 'internal-top-right-flap',
			label: 'Klapa górna prawa (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'sideFlapWidth', vertical: 'shortFlapDepth' },
		},
		{
			id: 'internal-bottom',
			label: 'Dno (wewnętrzne)',
			group: 'internal',
			description: 'Wewnętrzny spód – dobre miejsce na dodatkowe komunikaty brandowe.',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
	],
	'box-die-cut': [
		{
			id: 'external-front',
			label: 'Front (zewnętrzny)',
			group: 'external',
			description: 'Ściana frontowa z klapą automatyczną.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-back',
			label: 'Tył (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-back-flap',
			label: 'Klapa tylna (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-top',
			label: 'Pokrywa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
		{
			id: 'external-bottom',
			label: 'Dno (zewnętrzne)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
		{
			id: 'external-step-7',
			label: 'Panel pośredni (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-left',
			label: 'Bok lewy (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'external-left-flap',
			label: 'Klapa lewa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'height', vertical: 'depth' },
		},
		{
			id: 'external-right',
			label: 'Bok prawy (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'external-right-flap',
			label: 'Klapa prawa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'height', vertical: 'depth' },
		},
		{
			id: 'external-left-2',
			label: 'Bok lewy 2 (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'external-right-2',
			label: 'Bok prawy 2 (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'external-step-8-left',
			label: 'Skrzydło lewe (zewnętrzne)',
			group: 'external',
			axes: { horizontal: 'height', vertical: 'depth' },
		},
		{
			id: 'external-step-9-right',
			label: 'Skrzydło prawe (zewnętrzne)',
			group: 'external',
			axes: { horizontal: 'height', vertical: 'depth' },
		},
		{
			id: 'external-step-10-left',
			label: 'Klapa boczna lewa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'external-step-11-right',
			label: 'Klapa boczna prawa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'external-step-12-left',
			label: 'Skrzydełko lewe (zewnętrzne)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'external-step-13-right',
			label: 'Skrzydełko prawe (zewnętrzne)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'external-step-14-left',
			label: 'Klapa górna lewa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapDepth', vertical: 'width' },
		},
		{
			id: 'external-step-15-right',
			label: 'Klapa górna prawa (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'dieCutDustFlapDepth', vertical: 'width' },
		},
		{
			id: 'external-step-16-left',
			label: 'Panel dolny lewy (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'height', vertical: 'height' },
		},
		{
			id: 'external-step-17-right',
			label: 'Panel dolny prawy (zewnętrzny)',
			group: 'external',
			axes: { horizontal: 'height', vertical: 'height' },
		},
		{
			id: 'external-tuck-top',
			label: 'Klapa zamykająca (zewnętrzna)',
			group: 'external',
			axes: { horizontal: 'width', vertical: 'dieCutTuckDepth' },
		},
		{
			id: 'internal-tuck-top',
			label: 'Klapa zamykająca (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'dieCutTuckDepth' },
		},
		{
			id: 'internal-lid',
			label: 'Pokrywa (wewnętrzna)',
			group: 'internal',
			description: 'Widoczna po otwarciu – idealna na wiadomość powitalną.',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
		{
			id: 'internal-back',
			label: 'Panel górny (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
		{
			id: 'internal-base',
			label: 'Dno (wewnętrzne)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
		{
			id: 'internal-front',
			label: 'Panel frontowy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'internal-step-7',
			label: 'Panel pośredni (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'internal-step-8-left',
			label: 'Skrzydło lewe (wewnętrzne)',
			group: 'internal',
			axes: { horizontal: 'height', vertical: 'depth' },
		},
		{
			id: 'internal-step-9-right',
			label: 'Skrzydło prawe (wewnętrzne)',
			group: 'internal',
			axes: { horizontal: 'height', vertical: 'depth' },
		},
		{
			id: 'internal-left',
			label: 'Bok lewy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'internal-right',
			label: 'Bok prawy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
		{
			id: 'internal-step-10-left',
			label: 'Klapa boczna lewa (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'internal-step-11-right',
			label: 'Klapa boczna prawa (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'internal-step-12-left',
			label: 'Skrzydełko lewe (wewnętrzne)',
			group: 'internal',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'internal-step-13-right',
			label: 'Skrzydełko prawe (wewnętrzne)',
			group: 'internal',
			axes: { horizontal: 'dieCutDustFlapWidth', vertical: 'depth' },
		},
		{
			id: 'internal-step-14-left',
			label: 'Klapa górna lewa (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'dieCutDustFlapDepth', vertical: 'width' },
		},
		{
			id: 'internal-step-15-right',
			label: 'Klapa górna prawa (wewnętrzna)',
			group: 'internal',
			axes: { horizontal: 'dieCutDustFlapDepth', vertical: 'width' },
		},
		{
			id: 'internal-step-16-left',
			label: 'Panel dolny lewy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'height', vertical: 'height' },
		},
		{
			id: 'internal-step-17-right',
			label: 'Panel dolny prawy (wewnętrzny)',
			group: 'internal',
			axes: { horizontal: 'height', vertical: 'height' },
		},
		{
			id: 'internal-sides',
			label: 'Boki (wewnętrzne)',
			group: 'internal',
			axes: { horizontal: 'depth', vertical: 'height' },
		},
	],
	envelope: [
		{
			id: 'external-front',
			label: 'Przód koperty',
			group: 'external',
			description: 'Główna strona nadawcza.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'external-back-body',
			label: 'Tył koperty',
			group: 'external',
			description: 'Strona zamknięcia koperty.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'internal-front',
			label: 'Przód koperty (wewnętrzny)',
			group: 'internal',
			description: 'Wewnętrzna strona przodu koperty.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
		{
			id: 'internal-back-body',
			label: 'Tył koperty (wewnętrzny)',
			group: 'internal',
			description: 'Wewnętrzna strona korpusu koperty.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
	],
	'paper-bag': [
		{
			id: 'external-front',
			label: 'Przód torby',
			group: 'external',
			description: 'Główna powierzchnia nadruku z przodu torby.',
			axes: { horizontal: 'width', vertical: 'paperBagWallHeight' },
		},
		{
			id: 'external-back',
			label: 'Tył torby',
			group: 'external',
			description: 'Tylna ścianka torby.',
			axes: { horizontal: 'width', vertical: 'paperBagWallHeight' },
		},
		{
			id: 'external-left',
			label: 'Bok lewy',
			group: 'external',
			description: 'Lewy bok (fałda) torby.',
			axes: { horizontal: 'paperBagWallHeight', vertical: 'paperBagSideWidth' },
		},
		{
			id: 'external-right',
			label: 'Bok prawy',
			group: 'external',
			description: 'Prawy bok (fałda) torby.',
			axes: { horizontal: 'paperBagWallHeight', vertical: 'paperBagSideWidth' },
		},
		{
			id: 'external-bottom',
			label: 'Dno torby',
			group: 'external',
			description: 'Spód torby – miejsce zagięcia.',
			axes: { horizontal: 'width', vertical: 'depth' },
		},
	],
	tape: [
		{
			id: 'external-front',
			label: 'Pas taśmy',
			group: 'external',
			description: 'Obszar nadruku powtarzalnego na taśmie.',
			axes: { horizontal: 'width', vertical: 'height' },
		},
	],
};

const DEFAULT_SURFACE_KEY: BoxModelStyle = 'box-flap';

export const getProductSurfaces = (
	productTypeKey?: string | null,
	boxStyle: BoxModelStyle = DEFAULT_SURFACE_KEY
) => {
	if (productTypeKey && PRODUCT_SURFACES[productTypeKey]) {
		return PRODUCT_SURFACES[productTypeKey];
	}
	return PRODUCT_SURFACES[boxStyle] ?? PRODUCT_SURFACES[DEFAULT_SURFACE_KEY];
};

